import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2099">
      <div className="dark" data-id="element-2100">
        <Hero data-id="element-2101" />
      </div>
      <WhyUs data-id="element-2102" />
      <Services data-id="element-2103" />
      <HowItWorks data-id="element-2104" />
      <FAQ data-id="element-2105" />
      <Reviews data-id="element-2106" />
      <CtaBanner data-id="element-2107" />
    </main>;
}